export default __webpack_public_path__ + "static/media/pan-west.485531a6.png";